import axios from "../axios";

// Scope 2 v2 (categorized) data-entry API. Two resources under the
// /indirect-emissions/v2/ namespace — purchased electricity and on-site
// generation. Mirrors the indirect-emissions (v1) api shape.
const api = {
  getPurchasedElectricity(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(
      `/organization-questionnaires/${params.questionnaireId}/indirect-emissions/v2/purchased-electricity`,
      config).then(({ data }) => data);
  },

  addPurchasedElectricity({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(
      `/organization-questionnaires/${questionnaireId}/indirect-emissions/v2/purchased-electricity`,
      data, headers).then(({ data }) => data);
  },

  updatePurchasedElectricity({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(
      `/organization-questionnaires/${questionnaireId}/indirect-emissions/v2/purchased-electricity/${recordId}`,
      data, headers).then(({ data }) => data);
  },

  deletePurchasedElectricity({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(
      `/organization-questionnaires/${questionnaireId}/indirect-emissions/v2/purchased-electricity/${recordId}`,
      headers).then(({ data }) => data);
  },

  getOnsiteGeneration(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(
      `/organization-questionnaires/${params.questionnaireId}/indirect-emissions/v2/onsite-generation`,
      config).then(({ data }) => data);
  },

  addOnsiteGeneration({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(
      `/organization-questionnaires/${questionnaireId}/indirect-emissions/v2/onsite-generation`,
      data, headers).then(({ data }) => data);
  },

  updateOnsiteGeneration({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(
      `/organization-questionnaires/${questionnaireId}/indirect-emissions/v2/onsite-generation/${recordId}`,
      data, headers).then(({ data }) => data);
  },

  deleteOnsiteGeneration({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(
      `/organization-questionnaires/${questionnaireId}/indirect-emissions/v2/onsite-generation/${recordId}`,
      headers).then(({ data }) => data);
  },
};

export default api;
